module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-e10fa728cb25f508e6fadea893d36a79.svg";